export const DASHBOARD_COPY = {
  fr: {
    page: {
      title: "Mon espace",
      welcome: "Bienvenue",
      loadOrdersError: "Erreur lors du chargement des commandes",
      notificationReadError: "Impossible de marquer la notification comme lue.",
      notificationReadAllError: "Impossible de marquer les notifications comme lues.",
      portalError: "Impossible d'ouvrir le portail Stripe pour ce compte.",
      profileUpdated: "Profil mis à jour",
      profileUpdateError: "Erreur lors de la mise à jour du profil",
    },
    orders: {
      title: "Mes analyses",
      emptyTitle: "Aucune analyse pour le moment",
      emptyText: "Dès que vous envoyez une demande, son suivi apparaîtra ici.",
      firstOrder: "Créer ma première commande",
    },
    profile: {
      title: "Mon profil",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        whatsapp: "WhatsApp",
        club: "Club",
      },
      fullName: "Nom complet",
      email: "Email",
      notProvided: "Non renseigné",
      save: "Sauvegarder",
      cancel: "Annuler",
      edit: "Modifier",
    },
    quick: {
      title: "Actions rapides",
      activeOrders: "Mes commandes en cours",
      deliveredAnalyses: "Mes analyses livrées",
      pricing: "Voir les tarifs",
      newOrder: "Nouvelle commande",
      noCredit: "Aucun crédit disponible. Achetez une formule avant de créer une commande.",
      whatsapp: "Contacter sur WhatsApp",
    },
    subscription: {
      title: "Crédits disponibles",
      detailsPrefix: "dont",
      noCredit: "Aucun crédit disponible pour le moment.",
      subscription: "abonnement",
      freeSingular: "offert",
      freePlural: "offerts",
      collectiveSingular: "collectif",
      collectivePlural: "collectifs",
      individualSingular: "individuel",
      individualPlural: "individuels",
      createOrder: "Créer une commande",
      buyCredit: "Acheter un crédit",
      stripePortal: "Portail Stripe",
    },
    notifications: {
      title: "Notifications",
      history: "Historique",
      readAll: "Tout lire",
      empty: "Aucune notification pour le moment.",
      new: "Nouveau",
    },
    orderItem: {
      statuses: {
        delivered: "Livrée",
        in_progress: "En cours",
        pending: "Validée",
      },
      orderLabel: {
        collective: "Match Collectif",
        individual: "Match Individuel",
      },
      orderedOn: "Commandée le",
      daysLeft: "j restants",
      viewAnalysis: "Voir mon analyse",
      deliveredTitle: "Analyse livrée",
      deliveredText: "Analyse livrée",
      deliveredAccessible: "Votre analyse reste accessible depuis cet espace.",
      openAnalysis: "Ouvrir l'analyse",
      estimatedDelivery: "Livraison estimée",
      dayPlural: "jour(s)",
      progressText: "Mathis travaille sur votre analyse. Vous recevrez un email dès qu'elle sera prête.",
      tracking: "Suivi de l'analyse",
      trackingSteps: ["Commande validée", "Analyse en cours", "Analyse livrée"],
      analysis: "Analyse",
      analysisLink: "Lien de l'analyse",
      missingLink: "Lien non renseigné.",
      mathisMessage: "Message de Mathis",
      deliveredOn: "Livrée le",
      notDeliveredYet: "Pas encore livrée",
      whatsapp: "WhatsApp / contact",
      notProvided: "Non renseigné",
      sentVideo: "Lien vidéo envoyé",
      initialRequest: "Demande initiale",
      hide: "Masquer",
      viewRequest: "Voir la demande",
      editRequest: "Modifier ma demande",
      locked: "Modification verrouillée, analyse en cours",
      finished: "Commande terminée",
    },
  },
  en: {
    page: {
      title: "My space",
      welcome: "Welcome",
      loadOrdersError: "Unable to load orders",
      notificationReadError: "Unable to mark the notification as read.",
      notificationReadAllError: "Unable to mark notifications as read.",
      portalError: "Unable to open the Stripe portal for this account.",
      profileUpdated: "Profile updated",
      profileUpdateError: "Unable to update profile",
    },
    orders: {
      title: "My analyses",
      emptyTitle: "No analysis yet",
      emptyText: "As soon as you submit a request, its tracking will appear here.",
      firstOrder: "Create my first order",
    },
    profile: {
      title: "My profile",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        whatsapp: "WhatsApp",
        club: "Club",
      },
      fullName: "Full name",
      email: "Email",
      notProvided: "Not provided",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
    },
    quick: {
      title: "Quick actions",
      activeOrders: "My active orders",
      deliveredAnalyses: "My delivered analyses",
      pricing: "View pricing",
      newOrder: "New order",
      noCredit: "No credit available. Buy a plan before creating an order.",
      whatsapp: "Contact on WhatsApp",
    },
    subscription: {
      title: "Available credits",
      detailsPrefix: "including",
      noCredit: "No credit available for now.",
      subscription: "subscription",
      freeSingular: "free credit",
      freePlural: "free credits",
      collectiveSingular: "team credit",
      collectivePlural: "team credits",
      individualSingular: "individual credit",
      individualPlural: "individual credits",
      createOrder: "Create an order",
      buyCredit: "Buy a credit",
      stripePortal: "Stripe portal",
    },
    notifications: {
      title: "Notifications",
      history: "History",
      readAll: "Mark all as read",
      empty: "No notification for now.",
      new: "New",
    },
    orderItem: {
      statuses: {
        delivered: "Delivered",
        in_progress: "In progress",
        pending: "Confirmed",
      },
      orderLabel: {
        collective: "Team Match",
        individual: "Individual Match",
      },
      orderedOn: "Ordered on",
      daysLeft: "d left",
      viewAnalysis: "View my analysis",
      deliveredTitle: "Analysis delivered",
      deliveredText: "Analysis delivered",
      deliveredAccessible: "Your analysis remains accessible from this space.",
      openAnalysis: "Open analysis",
      estimatedDelivery: "Estimated delivery",
      dayPlural: "day(s)",
      progressText: "Mathis is working on your analysis. You will receive an email as soon as it is ready.",
      tracking: "Analysis tracking",
      trackingSteps: ["Order confirmed", "Analysis in progress", "Analysis delivered"],
      analysis: "Analysis",
      analysisLink: "Analysis link",
      missingLink: "Link not provided.",
      mathisMessage: "Message from Mathis",
      deliveredOn: "Delivered on",
      notDeliveredYet: "Not delivered yet",
      whatsapp: "WhatsApp / contact",
      notProvided: "Not provided",
      sentVideo: "Submitted video link",
      initialRequest: "Initial request",
      hide: "Hide",
      viewRequest: "View request",
      editRequest: "Edit my request",
      locked: "Editing locked, analysis in progress",
      finished: "Order completed",
    },
  },
};

export const getDashboardCopy = (language) => DASHBOARD_COPY[language] || DASHBOARD_COPY.fr;
